<template>
  <v-container class="cmpbk_drk white--text" id="home-container">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialog"
          width="500"
          overlay-color="accent"
          overlay-opacity="0.0"
          class="custom-dialog"
          dark
        >
          <v-card>
            <v-card-title class="text-h5 black lighten-2">
              Send a Invite
            </v-card-title>

            <v-card-text>
              <template>
                <v-form v-model="valid" ref="form">
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-text-field
                          v-model="invite.email"
                          :rules="emailRules"
                          label="E-mail"
                          required
                          :counter="60"
                          maxlength="60"
                        ></v-text-field>
                      </v-col> </v-row
                    ><v-row>
                      <v-col cols="12" md="12">
                        <v-text-field
                          v-model="invite.media_org"
                          :rules="nameRules"
                          :counter="60"
                          maxlength="60"
                          label="Media Org"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </template>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="accent black--text" @click="save_invite">
                <v-icon small mr-1 title="Media Sub. Invite"
                  >$appViewDash</v-icon
                >
                Send
              </v-btn>
              <v-btn class="accent black--text" @click="dialog = false">
                <v-icon small mr-1 title="Media Sub. Invite">$cancel</v-icon>
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <v-expansion-panels class="mt-4" dark v-model="panel">
      <v-expansion-panel dark>
        <v-expansion-panel-header>
          Public Subscriptions ({{ lst_subs.length }})
        </v-expansion-panel-header>
        <v-expansion-panel-content dark>
          <v-text-field
            class="mb-3"
            v-model="sterm"
            label="Search"
            prepend-inner-icon="$magnify"
            clearable
            outlined
            dense
            hide-details
            @keyup="findthem"
          ></v-text-field>
          <hr />
          <v-card
            color="cmpbk_drk"
            class="white--text mt-4 pubsub"
            shaped
            v-for="sub in lst_subs"
            :key="sub.news_subscriberId"
            style="width: 96%; margin-left: 2%; margin-right: 2%"
          >
            <v-card-text
              class="font-weight-bold white--text mt-2"
              style="font-size: 1.1rem"
            >
              <label>Email:</label> "{{ sub.email }}"
              <label>Date Subscribed:</label>
              {{ sub.s_CreateDate }}
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="accent black--text ml-1 mt-1 mb-2"
                @click="delprompt(sub)"
              >
                <v-icon small mr-1 title="Cancel release">$del</v-icon>
                Delete
              </v-btn>
            </v-card-actions>
          </v-card>
          <p class="ml-3" v-if="lst_subs.length == 0">
            Currently there are no subscriptions.
          </p>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel dark>
        <v-expansion-panel-header>
          Media Subscriptions ({{ lst_media_subs.length }})
        </v-expansion-panel-header>
        <v-expansion-panel-content dark>
          <v-text-field
            class="mb-3"
            v-model="sterm2"
            label="Search"
            prepend-inner-icon="$magnify"
            clearable
            outlined
            dense
            hide-details
            @keyup="findthem2"
          ></v-text-field>
          <hr />
          <v-card color="cmpbk_drk" class="white--text mt-1 mediasub" shaped>
            <v-card-text>
              <v-row dense>
                <v-col cols="12" cols-md-6>
                  <v-btn
                    class="accent black--text ml-1 mt-1 mb-2"
                    @click="show_invite_diag"
                  >
                    <v-icon small mr-1 title="Media Sub. Invite"
                      >$appViewDash</v-icon
                    >
                    Send a Media Sub. Invite
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card
            color="cmpbk_drk"
            class="white--text"
            shaped
            v-for="sub in lst_media_subs"
            :key="sub.news_subscriberId"
            style="width: 96%; margin-left: 2%; margin-right: 2%"
          >
            <v-card-text
              class="font-weight-bold white--text mt-2"
              style="font-size: 1.1rem"
            >
              <v-row dense>
                <v-col cols="12" cols-md-6>
                  <label>Email:</label> {{ sub.email }}
                </v-col>
                <v-col cols="12" cols-md-6>
                  <label>Date Subscribed:</label>
                  {{ sub.s_CreateDate }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" cols-md-12>
                  <label>Media Org:</label> {{ sub.media_org }}
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="accent black--text ml-1 mt-1 mb-2"
                @click="delprompt_media(sub)"
              >
                <v-icon small mr-1 title="Cancel release">$del</v-icon>
                Delete
              </v-btn>
            </v-card-actions>
          </v-card>
          <p class="ml-3" v-if="lst_subs.length == 0">
            Currently there are no subscriptions.
          </p>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- <v-spacer style="height: 20px"></v-spacer> -->
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
.custom-dialog >>> .v-overlay__scrim {
  background-color: rgba(0, 0, 0, 0) !important;
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "subscriptions",
  mixins: [bus_common],
  data() {
    return {
      sterm: "",
      sterm2: "",
      valid: false,
      firstname: "",
      lastname: "",
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => v.length <= 60 || "Name must be less than 10 characters",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      dialog: false,
      lst_subs: [],
      lst_media_subs: [],
      panel: 0,
      invite: {
        email: "",
        media_org: "",
      },
      invite_new: {
        email: "",
        media_org: "",
      },
    };
  },
  filters: {
    formatDateToString: function (strdate) {
      var jsdate = new Date(strdate);
      var day = jsdate.getDate();
      var month = jsdate.getMonth() + 1; // Months are zero-based
      var year = jsdate.getFullYear();

      // Add leading zeros to day and month if needed
      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }

      return month + "/" + day + "/" + year;
    },
  },
  methods: {
    findthem() {
      //if searching
      if (this.sterm.length >= 3) {
        const elements = document.querySelectorAll(".pubsub");

        elements.forEach((el) => {
          el.style.display = "none";
        });
        elements.forEach((el) => {
          if (
            el.innerHTML.toLowerCase().indexOf(this.sterm.toLowerCase()) > -1
          ) {
            el.style.display = "block";
          }
        });
      }
      //if emapty
      if (this.sterm.length == 0) {
        const elements = document.querySelectorAll(".pubsub");

        elements.forEach((el) => {
          el.style.display = "block";
        });
      }
    },
    findthem2() {
      //if searching
      if (this.sterm.length >= 3) {
        const elements = document.querySelectorAll(".mediasub");

        elements.forEach((el) => {
          el.style.display = "none";
        });
        elements.forEach((el) => {
          if (
            el.innerHTML.toLowerCase().indexOf(this.sterm.toLowerCase()) > -1
          ) {
            el.style.display = "block";
          }
        });
      }
      //if emapty
      if (this.sterm.length == 0) {
        const elements = document.querySelectorAll(".mediasub");

        elements.forEach((el) => {
          el.style.display = "block";
        });
      }
    },
    show_invite_diag() {
      this.dialog = true;
    },
    save_invite() {
      if (this.$refs.form.validate() == false) {
        this.show_loader(false);
        this.swall_it(
          "Sending Status",
          "Please address the red fields.",
          "warning",
          null,
          null
        );
        return true;
      }
      this.show_loader(true);
      let formIn = {};
      //date is in sql format in local var

      formIn.invite = this.mno(this.invite);
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "save_invite";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.dialog = false;
          self.get_media_subs();
          this.swall_it("Sending Status", "Invite Sent", "success", null, null);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    delprompt(sub) {
      console.log("delprompt");
      let self = this;
      this.swall_diag(
        "Confirm Delete",
        "Would you like to continue deleting the subscription for '" +
          sub.email +
          "' created on '" +
          sub.s_CreateDate +
          "' ?",
        "question",
        function () {
          self.del_sub(sub);
        },
        null,
        null,
        function () {}
      );
    },
    delprompt_media(sub) {
      console.log("delprompt_media");
      let self = this;
      this.swall_diag(
        "Confirm Delete",
        "Would you like to continue deleting the subscription for '" +
          sub.email +
          "' created on '" +
          sub.s_CreateDate +
          "' ?",
        "question",
        function () {
          console.log("del_sub_media");
          self.del_sub_media(sub);
        },
        null,
        null,
        function () {}
      );
    },
    del_sub(sub) {
      console.log("IN del_sub_media");
      this.mrbreakpoint("submedia");
      this.show_loader(true);
      let formIn = {};
      formIn.news_subscriberId = sub.news_subscriberId;
      //date is in sql format in local var
      formIn.token = this.$store.state.user.token;
      formIn.email = this.$store.state.user.email;
      formIn.apiname = "del_sub";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(true);
          self.get_all_subs();
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    del_sub_media(sub) {
      console.log("IN del_sub_media");
      this.mrbreakpoint("submedia");
      this.show_loader(true);
      let formIn = {};
      formIn.news_media_subscribersId = sub.news_media_subscribersId;
      //date is in sql format in local var
      formIn.token = this.$store.state.user.token;
      formIn.email = this.$store.state.user.email;
      formIn.apiname = "del_sub_media";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(true);
          self.get_media_subs();
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    get_all_subs(news_releaseId) {
      console.log("get_all_subs");

      this.show_loader(true);
      let formIn = {};

      formIn.token = this.$store.state.user.token;
      formIn.email = this.$store.state.user.email;
      formIn.apiname = "get_all_subs";

      let self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.lst_subs = self.mno(data);
          for (let index = 0; index < self.lst_subs.length; index++) {
            const element = self.lst_subs[index];
            element.s_CreateDate = self.format_date_us(element.s_CreateDate);
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    get_media_subs(news_releaseId) {
      console.log("get_media_subs");

      this.show_loader(true);
      let formIn = {};

      formIn.token = this.$store.state.user.token;
      formIn.email = this.$store.state.user.email;
      formIn.apiname = "get_media_subs";

      let self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.lst_media_subs = self.mno(data);
          for (let index = 0; index < self.lst_media_subs.length; index++) {
            const element = self.lst_media_subs[index];
            element.s_CreateDate = self.format_date_us(element.s_CreateDate);
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },

    message1() {
      alert("This button does nothing yet.");
    },
    init() {
      this.get_all_subs();
      this.get_media_subs();
      this.invite = this.invite_new;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
